import { useMediaQuery } from '@react-hookz/web';
import { useState } from 'react';

import Heading from 'components/Heading';
import OffsetSwitcher from 'components/OffsetSwitcher';

import type { ContentfulComponentToggle } from 'graphqlTypes';
import type { FC } from 'react';

const Toggle: FC<ContentfulComponentToggle> = ({ header: heading, refs, segment }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const isMobile = useMediaQuery('(max-width:640px)');

  const showDropdown = isMobile && segment?.length > 2;

  return (
    <>
      <Heading {...heading} />
      <div className="flex justify-center ">
        <div className={`flex rounded-lg bg-gray-200 p-2 ${showDropdown ? 'w-[90%] flex-col' : ''} justify-center`}>
          {segment?.map((seg, i) => (
            <button
              className={`rounded-lg px-8 py-5 md:px-16 ${currentIndex === i ? 'bg-white font-semibold text-green-600' : ''}`}
              onClick={() => setCurrentIndex(i)}
              key={seg}
            >
              {seg}
            </button>
          ))}
          {}
        </div>
      </div>
      <OffsetSwitcher {...refs[currentIndex]} />
    </>
  );
};

export default Toggle;
